/* eslint-disable no-console */
import moment from "@/utils/moment"
import { forEach } from "lodash"
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from "vue-router"

export default class ForceTypes implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    try {
      forEach(to.params, (param: string, key: string) => {
        if (param === null || param === undefined) {
          return (to.params[key] = undefined)
        }
        if (!isNaN(param)) {
          return (to.params[key] = Number(param))
        }
        if (param === "true" || param === "false") {
          return (to.params[key] = Boolean(param))
        }

        // disable js warnings temporarily
        const warning = console.warn
        console.warn = () => {}
        if (moment(param).isValid()) {
          return (to.params[key] = moment(param))
        }
        console.warn = warning
      })
    } catch (error) { /**/ }

    await next(to, from, cancel)
  }
}
